import React from 'react'
import PropTypes from "prop-types";
import Organisation from "./Organisation";

const OrganisationsList = (props) => {
  return (
    <>
      <div className="row row-cols-1 row-cols-md-3 g-4" data-testid="orga-list">
        {props.organisations.map((orga, index) => (
          <div className="col" key={index}>
            <Organisation
              {...orga}
              linkPrefix={props.organisationLinkPrefix}
              onOrderClick={props.onOrderClickForOrga}
            />
          </div>
        ))}
      </div>
    </>
  );
};

OrganisationsList.propTypes = {
  organisations: PropTypes.array.isRequired,
  onOrderClickForOrga: PropTypes.func.isRequired,
  organisationLinkPrefix: PropTypes.string,
};

export default OrganisationsList;
